module.exports = __webpack_public_path__ + "img/VETERINARIA.7b76c3e3.png";